import type { AnyObject } from "@regrello/core-utils";

export function getErrorMessageWithPayload<T extends AnyObject>(message: string, payload: T) {
  return message + " " + JSON.stringify(payload);
}
